export enum GarageType {
  BOX = 'BOX',
  POSTO_AUTO = 'POSTO_AUTO',
  RIMESSA = 'RIMESSA',
}
